import { Typography } from '@mui/material';
import Grid from 'components/core/Grid';
import { listGuestSuitabilityImage, listSimpleManagementImage, listCommunitySupportImage } from 'config/imageUrls';
import { ListPageAnchorEnum } from '../types';

import { ContentSection } from './styles';

export const JoinMarketplace = () => {
  return (
    <div id={ListPageAnchorEnum.overview}>
      <ContentSection>
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <Typography variant="h2" textAlign="center" mb={4}>
              Join the marketplace. Support your community.
            </Typography>
          </Grid>
          <Grid item xs={12} sm={4} sx={{ textAlign: 'center' }}>
            <img src={listGuestSuitabilityImage} width="160px" />
            <Typography variant="h3">Your Property. Your Rules.</Typography>
            <Typography>
              Decide who stays in your property with a robust set of eligibility settings, cancellation policies and
              guest requirements.
            </Typography>
          </Grid>
          <Grid item xs={12} sm={4} sx={{ textAlign: 'center' }}>
            <img src={listSimpleManagementImage} width="160px" />
            <Typography variant="h3">Diversify Your Guests.</Typography>
            <Typography>
              Access a group of high-quality guests from around the world. Our marketing targets seasoned mountain
              resort travellers.
            </Typography>
          </Grid>
          <Grid item xs={12} sm={4} sx={{ textAlign: 'center' }}>
            <img src={listCommunitySupportImage} width="160px" />
            <Typography variant="h3">Community Supportive</Typography>
            <Typography>
              A booking platform where property listings adhere to local rules and regulation for short-term rental
              zoning and tax compliance.
            </Typography>
          </Grid>
        </Grid>
      </ContentSection>
    </div>
  );
};
